





























import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { SigningPageDocument } from '@getaccept/lib-shared/src/types/signing-page-document';
import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import { ModalSizes } from '@getaccept/lib-shared/src/enums/ModalSizes';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import RecipientsTable from './RecipientsTable.vue';
import Sender from './Sender.vue';

export default defineComponent({
  components: {
    RecipientsTable,
    Sender,
  },
  props: {
    document: {
      type: Object as PropType<SigningPageDocument>,
      required: true,
    },
    company: {
      type: String,
      default: '',
    },
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    recipients: {
      type: Array as PropType<SigningPageRecipient[]>,
      required: true,
    },
    isSigningOrder: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    currentRecipientsTurnToSign: {
      type: Boolean,
      default: false,
    },
    recipientsTurnToSign: {
      type: Object as PropType<SigningPageRecipient>,
      default: undefined,
    },
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
  },
  setup(props) {
    const title = computed((): string => `${t('recipients')} (${props.recipients.length})`);

    const showInviteButton = computed((): boolean => {
      if (props.isPreview) {
        return false;
      }
      return ![
        DocumentStatus.Signed,
        DocumentStatus.Recalled,
        DocumentStatus.Rejected,
        DocumentStatus.Lost,
      ].includes(props.document.status);
    });

    const signingOrderMessage = computed((): string => {
      if (!props.isSigningOrder) {
        return '';
      }

      if (props.currentRecipientsTurnToSign) {
        return t('your-turn-to-sign');
      }

      if (!props.recipientsTurnToSign) {
        return t('other-turn-to-sign-hidden');
      }

      return t('other-turn-to-sign', { name: props.recipientsTurnToSign.fullName });
    });

    return {
      ModalSizes,
      title,
      showInviteButton,
      signingOrderMessage,
    };
  },
});
